$(() => {
  $("input[type='tel']").on('input', function() {
    $(this).val($(this).val().replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/[^0-9]/g,''))
  })
})
